import React, { useState } from 'react';
import Layout from '../components/Layout'; // Assuming Layout is being used here as well
import {
  Box,
  TextField,
  Button,
  Typography,
  Autocomplete,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Import the CSS for the date picker

const CreateProjectPage = () => {
  const [projectName, setProjectName] = useState('');
  const [projectDescription, setProjectDescription] = useState('');
  const [client, setClient] = useState('');
  const [priceType, setPriceType] = useState('hourly');
  const [price, setPrice] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // Sample clients array
  const clients = [
    { label: 'Drilon' },
    { label: 'Demco' },
    { label: 'Client 3' },
    { label: 'Client 4' },
    { label: 'Client 5' },
  ];

  const handleSubmit = () => {
    // Handle project creation logic here
    alert('Project Created!');
  };

  return (
    <Layout>
      <Box sx={{ padding: 3, maxWidth: 900, margin: '0 auto' }}>
        <Typography
          variant="h3"
          gutterBottom
          sx={{
            fontWeight: 'bold',
            color: '#1a237e',
            textTransform: 'uppercase',
            letterSpacing: 1.5,
          }}
        >
          Create New Project
        </Typography>
        <form onSubmit={handleSubmit}>
          {/* Searchable Client Dropdown */}
          <Autocomplete
            value={client}
            onChange={(event, newValue) => setClient(newValue)}
            disablePortal
            options={clients}
            getOptionLabel={(option) => option.label}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Client"
                required
                variant="outlined"
                fullWidth
                sx={{
                  marginBottom: 2,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '15px',
                  },
                }}
              />
            )}
          />

          {/* Project Name */}
          <TextField
            label="Project Name"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
            fullWidth
            margin="normal"
            variant="outlined"
            required
            sx={{
              marginBottom: 2,
              '& .MuiOutlinedInput-root': {
                borderRadius: '15px',
              },
            }}
          />

          {/* Project Description */}
          <TextField
            label="Project Description"
            value={projectDescription}
            onChange={(e) => setProjectDescription(e.target.value)}
            fullWidth
            margin="normal"
            multiline
            rows={4}
            variant="outlined"
            required
            sx={{
              marginBottom: 2,
              '& .MuiOutlinedInput-root': {
                borderRadius: '15px',
              },
            }}
          />

          {/* Price Type Radio Button */}
          <FormControl component="fieldset" margin="normal">
            <FormLabel component="legend">Price Type</FormLabel>
            <RadioGroup
              value={priceType}
              onChange={(e) => setPriceType(e.target.value)}
            >
              <FormControlLabel
                value="hourly"
                control={<Radio />}
                label="Price Per Hour"
              />
              <FormControlLabel
                value="fixed"
                control={<Radio />}
                label="Fixed Price"
              />

            </RadioGroup>
          </FormControl>

          {/* Price Input */}
          <TextField
            label="Price"
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            fullWidth
            margin="normal"
            variant="outlined"
            required
            sx={{
              marginBottom: 2,
              '& .MuiOutlinedInput-root': {
                borderRadius: '15px',
              },
            }}
          />

          {/* Start Date */}
          <Box sx={{ marginBottom: 2 }}>
            <Typography variant="body1" gutterBottom>
              Start Date
            </Typography>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              dateFormat="dd-MM-yyyy"
              showMonthDropdown
              showYearDropdown
              scrollableYearDropdown
              className="custom-date-picker"
              required
            />
          </Box>

          {/* End Date */}
          <Box sx={{ marginBottom: 2 }}>
            <Typography variant="body1" gutterBottom>
              End Date
            </Typography>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              dateFormat="yyyy-MM-dd"
              showMonthDropdown
              showYearDropdown
              scrollableYearDropdown
              className="custom-date-picker"
              required
            />
          </Box>

          {/* Submit Button */}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            startIcon={<SaveIcon />}
            sx={{
              marginTop: 2,
              borderRadius: '20px',
              backgroundColor: '#1a237e',
              '&:hover': {
                backgroundColor: '#303f9f',
              },
            }}
          >
            Save Project
          </Button>
        </form>
      </Box>
    </Layout>
  );
};

export default CreateProjectPage;
